import React, { useContext, useEffect, useState } from "react";
import AuthContext from "../../services/firebase/auth-context/provider";
import { useLocation } from "@reach/router";
import SiteOverlay from "../site-overlay";
import Login from "../login/login";
import { Link } from "gatsby";
import * as styles from "./login-popup.module.css";
var AlertMsgComponent = function AlertMsgComponent(_ref) {
    var alertMsg = _ref.alertMsg, setAlertMsgStatus = _ref.setAlertMsgStatus;
    var title = alertMsg.mode === "LOGIN_REQUIRED" ? "Anmeldung erforderlich" : "Abonnement erforderlich";
    var message = alertMsg.mode === "LOGIN_REQUIRED" ? "Melden Sie sich mit ihrem bestehendem Account an oder registrieren Sie sich, um diese Funktion nutzen zu können." : "Diese Funktion ist nur für Abonennten verfügbar.";
    return /*#__PURE__*/ React.createElement("div", {
        className: styles.alertContainer
    }, /*#__PURE__*/ React.createElement("div", {
        className: "content-text"
    }, /*#__PURE__*/ React.createElement("h5", {
        className: "mb-2"
    }, title), message), alertMsg.mode === "LOGIN_REQUIRED" ? /*#__PURE__*/ React.createElement("button", {
        className: styles.loginLink,
        onClick: function onClick() {
            return setAlertMsgStatus(false);
        }
    }, "Anmelden") : /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Link, {
        to: "/abonnieren",
        className: styles.loginLink
    }, "Werden Sie Abonnent!"), /*#__PURE__*/ React.createElement("p", {
        className: "mt-3"
    }, "Schon Abonnent? Dann hier", " ", /*#__PURE__*/ React.createElement("span", {
        className: styles.loginSubLink,
        onClick: function onClick() {
            return setAlertMsgStatus(false);
        }
    }, "einloggen"), "!")));
};
var LoginPopup = function LoginPopup(_ref2) {
    var shouldShowPopup = _ref2.shouldShowPopup, onClose = _ref2.onClose, _ref2$alertMsg = _ref2.alertMsg, alertMsg = _ref2$alertMsg === void 0 ? {
        status: false,
        mode: null
    } : _ref2$alertMsg;
    var authenticated = useContext(AuthContext)[0].authenticated;
    var _useState = useState(alertMsg.status), showAlertMsg = _useState[0], setAlertMsgStatus = _useState[1];
    var location = useLocation();
    useEffect(function () {
        var msgTime;
        if (authenticated) {
            msgTime = setTimeout(function () {
                setAlertMsgStatus(false);
                onClose();
            }, 2000);
        }
        return function () {
            return clearTimeout(msgTime);
        };
    }, [authenticated, shouldShowPopup]);
    var closeModal = function closeModal() {
        alertMsg.status && setAlertMsgStatus(true);
        onClose();
    };
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(SiteOverlay, {
        onClose: closeModal,
        open: location.pathname !== "/anmelden/" && shouldShowPopup
    }, /*#__PURE__*/ React.createElement("div", {
        className: "p-4"
    }, showAlertMsg ? /*#__PURE__*/ React.createElement(AlertMsgComponent, {
        alertMsg: alertMsg,
        setAlertMsgStatus: setAlertMsgStatus
    }) : null, showAlertMsg ? null : !authenticated ? /*#__PURE__*/ React.createElement(Login, null) : /*#__PURE__*/ React.createElement("div", {
        className: styles.successMsg,
        role: "alert"
    }, /*#__PURE__*/ React.createElement("p", null, "Sie wurden erfolgreich angemeldet!")))));
};
export default LoginPopup;
